import axios from 'axios';
import {useState, useRef, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';

import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import SearchIcon from '@mui/icons-material/Search';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import CustomerUsersEditRole from './CustomerUsersEditRole';
import PasswordReset from '../../common/PasswordReset';
import CustomerUsersEditCompanyLinkLookup from './CustomerUsersEditCompanyLinkLookup';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function UsersEdit(props) {
    //console.debug("RTS Break UsersEdit");

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const {user, sessionCustomer,  userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const history = useNavigate();
    //const display = props.display;
    const mode = props.mode;
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody, setErrorBody] = useState("");
    const [errorTitle, setErrorTitle] = useState("Validation Error");
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [showPasswordErrorModal, setShowPasswordErrorModal] = useState(false);
    const [showValidateRemoveModal, setShowValidateRemoveModal] = useState(false);
    const [showCompanyLinkModal, setShowCompanyLinkModal] = useState(false);

    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [password, setPassword] = useState();
    const [passwordToken, setPasswordToken] = useState();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [status, setStatus] = useState(1);
    const [adminFlag, setAdminFlag] = useState(0);
    const [reelAdminFlag, setReelAdminFlag] = useState(0);
    const [crossCustomerFlag, setCrossCustomerFlag] = useState(0);
    const [manufacturerFlag, setManufacturerFlag] = useState(0);
    const [distributorFlag, setDistributorFlag] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [licensedBy, setLicensedBy] = useState(null);
    const [licenseId, setLicenseId] = useState('');
    const [modReelsFlag, setModReelsFlag] = useState(1);
    const [modInventoryFlag, setmodInventoryFlag] = useState(0);
    const [modPalletsFlag, setModPalletsFlag] = useState(0);
    const [modManufacturingFlag, setModManufacturingFlag] = useState(0);
    const [modReelInspectionsFlag, setModReelInspectionsFlag] = useState(0);

    const [role, setRole] = useState(50);
    const [curCustomer, setCurCustomer] = useState();
    const [triggerUpdate, setTriggerUpdate] = useState(false);
    const [companyLink, setCompanyLink] = useState()
    const [markAccess, setMarkAccess] = useState(0)    
    const [fullAccess, setFullAccess] = useState(0);
    const [pickupRequestAccess, setPickupRequestAccess] = useState(0);    
    const formRef = useRef(null);


    const fetchData = useCallback((idGuid) => {
        let apiURL = apiRoot + "/AppUsers/GetAppUserById/" + idGuid;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);

                setEmail(response.data.email);
                setFirstName(response.data.firstName);
                setLastName(response.data.lastName);
                setPhoneNumber(response.data.phoneNumber);
                setPasswordToken(response.data.passwordToken);
                setStatus(response.data.status);
                setAdminFlag(response.data.adminFlag);
                setReelAdminFlag(response.data.reelAdminFlag);
                setCrossCustomerFlag(response.data.crossCustomerFlag);
                setManufacturerFlag(response.data.manufacturerFlag);
                setDistributorFlag(response.data.distributorFlag);
                setCustomers(response.data.appUserCustomers);
                setLicensedBy(response.data.licensedBy!==null?response.data.licensedBy:null);
                setLicenseId(response.data.licenseId!==null?response.data.licenseId:null);
                setModReelsFlag(response.data.modReelsFlag);
                setmodInventoryFlag(response.data.modInventoryFlag);
                setModPalletsFlag(response.data.modPalletsFlag);
                setModManufacturingFlag(response.data.modManufacturingFlag);
                setModReelInspectionsFlag(response.data.modReelInspectionsFlag);

                let tmpCust = response.data.appUserCustomers.filter(c => c.customer.idGuid === sessionCustomer.customer.idGuid);
                if(tmpCust.length > 0){
                    setRole(tmpCust[0].accessLevel);
                    setCurCustomer(tmpCust[0]);
                    setCompanyLink(tmpCust[0].companyLink);
                    setMarkAccess(tmpCust[0].markAccess);    
                    setFullAccess(tmpCust[0].fullAccess);
                    setPickupRequestAccess(tmpCust[0].pickupRequestAccess);                    
                }
                
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status == 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]);

    
    useEffect(() => {
        if(mode === 1){
            fetchData(props.idGuid);
        }
        else{
            setIsLoading(false);
        }

    }, [mode, fetchData, props.idGuid]);  


    useEffect(() =>{
        if(triggerUpdate){
            formRef.current.requestSubmit();
        }
    }, [triggerUpdate])


    function handleSubmit(e) {
        e.preventDefault();

        if(email === null){
            setErrorTitle("Validation Error");
            setErrorBody("User Email is required");
            setShowErrorModal(true);
            return;
        }

        executeSubmit();
    }; 


    function executeSubmit() {

        let custList = [];
        if(curCustomer != null){
            customers.forEach(cc => {
                if(cc.customer.idGuid !== sessionCustomer.customer.idGuid)
                {
                    custList.push(cc)
                }
            });

            custList.push(curCustomer);
        }
        else{
            custList = customers;
        }


        let apiObj = {
            userName: email,
            passwordHash: password,
            email: email,
            firstName: firstName,
            lastName: lastName,
            phoneNumber: phoneNumber,
            status: status,
            adminFlag: adminFlag,
            reelAdminFlag: reelAdminFlag,
            crossCustomerFlag: crossCustomerFlag,
            manufacturerFlag: manufacturerFlag,
            distributorFlag: distributorFlag,
            licensedBy: licensedBy,
            licenseId: licenseId===''?null:licenseId,
            appUserCustomers: custList,
            modifyUser: user.userName,
            clientUrl: window.location.origin,
            modReelsFlag: modReelsFlag,
            modInventoryFlag: modInventoryFlag,
            modPalletsFlag: modPalletsFlag,
            modManufacturingFlag: modManufacturingFlag,
            modReelInspectionsFlag: modReelInspectionsFlag
        }

        if(mode===0){
            apiObj.createUser = user.userName;
            apiObj.TOUFlag = 0;

            let apiURL = apiRoot + "/AppUsers/CreateAppUser";
            axios
                .post(
                    apiURL,
                    apiObj, 
                    {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
                )
                .then(response => {
                    history(-1);
                })
                .catch(error => {
                    setIsLoading(false);

                    if(error.status == 401){
                        userLogOut();
                    }
                    else{
                        setErrorTitle("InsertError");
                        setErrorBody("An error has occured.  Please review the console log for details.");
                        console.log("RTS CreateUser Error", error);
                        setShowErrorModal(true);
                    }


    
                });

        }
        else{
            let apiURL = apiRoot + "/AppUsers/UpdateAppUser";
            axios
                .put(
                    apiURL,
                    apiObj, 
                    {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
                )
                .then(response => {
                    history(-1);
                })
                .catch(error => {
                    setErrorTitle("Update Error");
                    setErrorBody("An error has occured.  Please review the console log for details.");
                    console.log("RTS UpdateUser Error", error);
                    setShowErrorModal(true);
                });
            }
    }; 


    function getToken(){
        if(mode===1){
            if(passwordToken==null){
                return -1;
            }
            else{
                return passwordToken;
            }
        }
        else{
            return -1;
        }
    };


    function setRoleVal(pValue){
        setRole(pValue);
        let tmpCust = curCustomer;
        tmpCust.accessLevel = pValue;
        setCurCustomer(tmpCust);
        props.setFormDirtyFx(1);        
    }


    function setCompanyLinkVal(pValue){
        setCompanyLink(pValue);
        let tmpCust = curCustomer;
        tmpCust.companyLink = pValue;
        setCurCustomer(tmpCust);        
        setShowCompanyLinkModal(false);
        props.setFormDirtyFx(1);        
    }; 
    

    function setMarkAccessVal(pValue){
        setMarkAccess(pValue);
        let tmpCust = curCustomer;
        tmpCust.markAccess = pValue;
        setCurCustomer(tmpCust);
        props.setFormDirtyFx(1);        
    }


    function setFullAccessVal(pValue){
        setFullAccess(pValue);
        let tmpCust = curCustomer;
        tmpCust.fullAccess = pValue;
        setCurCustomer(tmpCust);
        props.setFormDirtyFx(1);        
    }


    function setPickupRequestAccessVal(pValue){
        setPickupRequestAccess(pValue);
        let tmpCust = curCustomer;
        tmpCust.pickupRequestAccess = pValue;
        setCurCustomer(tmpCust);
        props.setFormDirtyFx(1);        
    }


    function removeAccess(){
        let newCustList = [];
        customers.forEach(cc => {
            if(cc.customer.idGuid !== sessionCustomer.customer.idGuid)
            {
                newCustList.push(cc)
            }
        });

        setCurCustomer(null);
        setCustomers(newCustList);
        setTriggerUpdate(true);
    }


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };    


    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <div>
                    {errorBody}
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog open={showPasswordModal} onClose={()=>{setShowPasswordModal(false);}}>
            <DialogContent>
                <Box>
                    <PasswordReset mode={1} userName={email} passwordToken={getToken()} setShowPasswordModalFx={setShowPasswordModal} />
                </Box>
            </DialogContent>
        </Dialog>
        <Dialog open={showPasswordErrorModal} onClose={()=>{setShowPasswordErrorModal(false);}}>
            <DialogTitle>Password Not Validated</DialogTitle>
            <DialogContent>
                <div>
                    <Typography>The password must meet the following criteria:</Typography>
                    <ul>
                        <li>At least 8 characters long.</li>
                        <li>At least 1 capital (uppercase) letter.</li>
                        <li>At least 1 lower case letter.</li>
                        <li>At least 1 number.</li>
                        <li>At least 1 special character.</li>
                        <li>Password and Password Confirm must match.</li>
                    </ul>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowPasswordErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog open={showValidateRemoveModal} onClose={()=>{setShowValidateRemoveModal(false);}}>
            <DialogTitle>Remove User Access?</DialogTitle>
            <DialogContent>
    		    <Typography variant="h5" sx={{mt:2}}>Remove access to company:</Typography>
                <Typography>{sessionCustomer.customer.name + " (" + sessionCustomer.customer.idSap + ")"}</Typography>
    		    <Typography variant="h5" sx={{mt:2}}>For User:</Typography>
                <Typography>{firstName + ' ' + lastName}</Typography>
                <Box>
                    <Box  sx={{textAlign:'center', mt:2}}>
                        <Button variant="contained" sx={{mr:2}} onClick={removeAccess}>Remove</Button>
                        <Button variant="contained" onClick={()=>{setShowValidateRemoveModal(false);}}>Cancel</Button> 
                    </Box>
                </Box>                    
            </DialogContent>
        </Dialog>
        <Dialog fullWidth={true} maxWidth="md" open={showCompanyLinkModal} onClose={()=>{setShowCompanyLinkModal(false);}}>
            <DialogTitle>Crew Member Company</DialogTitle>
            <DialogContent>
                <Box>
                    <CustomerUsersEditCompanyLinkLookup data={companyLink} setValueFx={setCompanyLinkVal} company={props.data} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowCompanyLinkModal(false);}} sx={{mr:2}}>Close</Button>
            </DialogActions>
        </Dialog>        
        <Box>
            <Box sx={{textAlign:"right"}}>
                <Button variant="contained" onClick={e =>{setShowPasswordModal(true);}}>Reset Password</Button>
            </Box>
            <form id="userForm" ref={formRef} onSubmit={handleSubmit}>
                <Box maxWidth="md" sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <Box maxWidth="sm" sx={{width:smallForm?'auto':'600px'}}>
                <TextField
                    id="tbEmail"
                    margin="normal"
                    fullWidth
                    label="User Email Address"
                    size="small"
                    required
                    value={email}
                    //onChange={(e) => {props.setFormDirtyFx(1); setEmail(e.target.value);}}
                    disabled={true}
                />
                <TextField
                    id="tbFirstName"
                    margin="normal"
                    fullWidth
                    label="First Name"
                    size="small"
                    required
                    value={firstName}
                    onChange={(e) => {props.setFormDirtyFx(1); setFirstName(e.target.value);}}
                />
                <TextField
                    id="tbLastName"
                    margin="normal"
                    fullWidth
                    label="Last Name"
                    size="small"
                    required
                    value={lastName}
                    onChange={(e) => {props.setFormDirtyFx(1); setLastName(e.target.value);}}
                />
                <TextField
                    id="tbPhoneNumber"
                    margin="normal"
                    fullWidth
                    label="Phone Number"
                    size="small"
                    value={phoneNumber}
                    onChange={(e) => {props.setFormDirtyFx(1); setPhoneNumber(e.target.value);}}
                />
                <Box id="CompanyLink" sx={{display:'flex', alignItems:'center'}}>
                    <TextField
                        id="tbCompanyLink"
                        margin="normal"
                        fullWidth
                        label="Company"
                        size="small"
                        value={companyLink==null?'':companyLink.name}
                        onClick={setShowCompanyLinkModal}
                    />
                    <Box sx={{ml:1, mt:1}}>            
                        <Button variant="contained" onClick={setShowCompanyLinkModal} >
                            <SearchIcon sx={{fontSize:'2em'}} />
                        </Button>
                    </Box>            
                </Box>                     
                <Box sx={{mt:2}}>
                    <Box sx={{display:'flex', width:'100%'}}>
                        <Box sx={{minWidth:'70%', mr:2}}>
                            <CustomerUsersEditRole role={role} setRoleFx={setRoleVal} setFormDirtyFx={props.setFormDirtyFx} />
                        </Box>
                        <Box sx={{display:'flex', alignItems:'center', justifyContent:'right', justifyItems:'right', width:'100%'}}>
                            <Button variant="contained" onClick={()=>{setShowValidateRemoveModal(true);}}>Remove Access</Button>
                        </Box>
                    </Box>
                </Box>
                <Box id="FullAccess" sx={{display:"flex", mt:1}}>
                    <FormControl component="fieldset" sx={{flexGrow:1}}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={fullAccess===1?true:false} 
                                            onChange={(e) => {e.target.checked?setFullAccessVal(1):setFullAccessVal(0);}} 
                                            name="cbxFullAccess" 
                                            disabled={role===1?false:true}
                                    />
                                }
                                label="Allow Full Reel Access"
                            />
                        </FormGroup> 
                    </FormControl>
                </Box>   
                <Box id="MarkAccess" sx={{display:"flex", mt:1}}>
                    <FormControl component="fieldset" sx={{flexGrow:1}}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={markAccess===1?true:false} 
                                            onChange={(e) => {e.target.checked?setMarkAccessVal(1):setMarkAccessVal(0);}} 
                                            name="cbxMarkAccess"
                                            disabled={role===1?false:true}
                                    />
                                }
                                label="Allow Reel Marks"
                            />
                        </FormGroup> 
                    </FormControl>
                </Box>
                <Box id="PickupRequestAccess" sx={{display:"flex", mt:1}}>
                    <FormControl component="fieldset" sx={{flexGrow:1}}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={pickupRequestAccess===1?true:false} 
                                            onChange={(e) => {e.target.checked?setPickupRequestAccessVal(1):setPickupRequestAccessVal(0);}} 
                                            name="cbxPickupRequestAccess" 
                                            disabled={role===1?false:true}
                                    />
                                }
                                label="Allow Pickup Request Access"
                            />
                        </FormGroup> 
                    </FormControl>
                </Box>                         
                </Box>
                </Box>                
                <Box sx={{textAlign:'center', mt:3}}>
                    <Button variant="contained" disabled={props.formDirty===1?false:true} type="submit">Save</Button>
                </Box>
            </form>
        </Box>
        </>
    );
}

